/* eslint-disable import/prefer-default-export */
export const StatusColor = {
  RECEIVED: '#2a8ef4',
  IN_PROGRESS: 'skyblue',
  RESOLVED: '#8BC34A',
  REJECT: '#FF5722',
  CLOSED: '#8BC34A',
  ACTIVE: '#2a8ef4',
  DISABLED: '#f50',
  SUCCESS: 'green',
  HOLD: 'yellow',
  APPROVED: 'blue',
  PENDING: 'pink',
  DECLINED: 'red',
  CANCELLED: 'purple',
  ON_HOLD: 'yellow',
  STARTED: '2a8ef4',
  COMPLETED: 'green',
  POSTBACK: 'blue',
  IS_OFFLINE: 'green',
  EXPIRED: '#c9c7c1',
  FAILED: 'red',
  FIRST_GOAL_MISMATCHED: '#df16eeff',
  GOAL_ORDER_MISMATCHED: '#14a0d8ff',
  GOAL_ALREADY_FAILED: '#8e9cabff',
  GOAL_ALREADY_EXPIRED: '#2a8ef4',
  GOAL_ALREADY_COMPLETED: '#17d854ff',
  GOAL_LOCKED: '#c0c1c3ff',
  GOAL_NOT_FOUND: '#2a8ef4',
  INVALID_GOAL: '#2a8ef4',
  ALREADY_COMPLETED: '#1de645ff',
  CALLBACK_NOT_FOUND: '#2a8ef4',
  CLICK_NOT_EXIST: '#8e2a1fff',
  CONVERSION_REACHED: '#2a8ef4',
  INVALID_CLICK_ID: '#523d90ff',
  MISSING_CLICK_ID: '#2a8ef4',
  NOT_ALLOWED_IP: '#2a8ef4',
  GOAL_CTIT_FAILED: '#2a8ef4',
  CTIT_FAILED: '#ac1ce0ff',
  PRE_CONDITION_FAILED: '#2a8ef4',
  GOAL_ON_HOLD: 'yellow',
  EMPTY_INSTALLED_AT: '#2a8ef4',
  UNAUTHORIZED: '#2a8ef4',
  INVALID_UUID: '#707020ff',
  PROCESSING: '#2a8ef4',
  EXCEPTION: '#199eb3ff',
};

export const CategoryTypeColor = {
  PARENT: '#2db7f5',
  CUSTOM: '#87d068',
};

export const ActiveColor = {
  0: 'red',
  1: 'blue',
  INACTIVE: 'red',
  ACTIVE: 'blue',
};

export const PriorityColor = {
  HIGH: 'red',
  MEDIUM: 'purple',
  LOW: 'green',
};

export const NewtorkColor = {
  MANUAL: 'purple',
  FLIPKART: 'red',
  ADMITAD: '#2db7f5',
  VCOMMISSION: '#8BC34A',
};

export const ReportColor = {
  IN_PROGRESS: 'blue',
  COMPLETED: 'green',
};

export const SchedulingTypeColor = {
  DAILY: '#2db7f5',
  NORMAL: '#87d068',
};

export const AdditionalCashbackStatusColor = {
  PENDING: '#2a8ef4',
  APPROVED: '#8BC34A',
  DISCARDED: '#FF5722',
};
